/**
 * VendorProductStatusService
 * Service for managing vendor product statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product status CRUD operations
 */
export class VendorProductStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductStatusService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorProductStatusService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductStatusService.BASE_PATH = 'api/vendor-product-statuses';
//# sourceMappingURL=VendorProductStatusService.js.map